// Import navigation components
import MainNavigation from "./components/main-navigation";
import MobileNavigation from "./components/mobile-navigation";

// Initialize navigation components
new MainNavigation();
new MobileNavigation();

// Import custom elements
import "./custom-elements/accordions";
import "./custom-elements/activity-tabs";
import "./custom-elements/activities-focus-box";
import "./custom-elements/quote-simple";
import "./custom-elements/illustration-page-not-found";
import "./custom-elements/illustration-footer";
import "./custom-elements/illustration-header-logo";
import "./custom-elements/service-menu";
import "./custom-elements/activity-map";
import "./custom-elements/activity-form";

// Import utility functions
import "./utility/utility";
